import main from '@/main.js'
import freeItem from "../components/popup/ModalFreeItem";
import ModalActionError from '../components/popup/ModalActionError'
import modalMessage from '@/components/popup/ModalNotify'

const Cart = {
  install(Vue, options = {}) {
    Vue.prototype.$cart = {
      init: function (vm) {
        vm.cart = this.get(vm)
      },
      // get cart
      get: function (vm) {
        // vm.$session.set('cart', "")
        let cart = vm.$session.get('cart')
        if (!cart || vm.empty(cart)) {
          cart = {
            'uuid': '',
            'customer_id': null,
            'tax_percent': 0,
            'tax_total': 0,
            'total': 0,
            'sub_total': 0,
            'data': []
          }
        }
        return cart
      },
      _modalActionShow (vm, error, message) {
        if (vm.$const.MESSAGES_CODE.INCREASE_TIME.indexOf(error) > -1 ){
          vm.$modal.show(ModalActionError, {
            message: message,
            isProcessOrder: true,
          })
        }
        if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_WITHOUT_TIME_RANGE_HAS_REASON.indexOf(error.code) > -1 ){
          vm.$modal.show(ModalActionError, {
            message: message,
            isRedirect: true,
            isChooseAnotherAddress: true
          })
        }
        if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(error.code) > -1 ){
          vm.$modal.show(ModalActionError, {
            message: message,
            isRedirect: true,
            isShowAdvanceTime: true,
            isChooseAnotherAddress: true
          })
        }
        if (vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIMEOUT_RANGE.indexOf(error.code) > -1 ){
          vm.$modal.show(ModalActionError, {
            message: message,
            isRedirect: true,
            isChooseAnotherAddress: true
          })
        }
        if (vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIME_RANGE.indexOf(error.code) > -1 ){
          vm.$modal.show(ModalActionError, {
            message: message,
            isRedirect: true,
            isShowAdvanceTime: true,
            isChooseAnotherAddress: true
          })
        }
      },
      getDetail: function (vm) {
        let cart = this.get(vm)
        let self = this

        if (cart.uuid) {
          let data = {'cart_id': cart.uuid}
          vm.axios.apiCart.getCart(data,
            function (response) {
              cart = response.data.data.item
              self.commit(vm, cart)
            }, function (error) {
              self.commit(vm, {})
            }
          )
        }
      },
      // insert item cart
      insert: function (vm, item) {
        let cart = this.get(vm)
        let self = this

        if (cart.uuid) {
          item.group.cart_id = cart.uuid
        }
        item.group.advance_order = vm.$disposition.getByKey(vm, 'advanceOrder', 0)
        item.group.order_time = vm.convertDateTimeToUTC(item.group.order_time)
        if(vm.$disposition.getByKey(vm, 'orderType', vm.$const.DELIVERY) == vm.$const.DELIVERY){
            item.lat = vm.$disposition.getByKey(vm, 'lat', ''),
            item.long = vm.$disposition.getByKey(vm, 'long', '')
        }
        if (cart.hasOwnProperty('is_use_condiment')) {
          item.group.require_condiment = cart.is_use_condiment
        }
        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.group.require_cutlery = cart.is_use_cutlery
        }
        // Send to API
        // Received response from API and set for cart
        var title = vm.$t('cart.add_success')
        var message = vm.$t('cart_invalid_selling_time') + (item.selling_start ? vm.convertUTCToClientTime(item.selling_start).format('YYYY-MM-DD HH:mm:ss') : '')
        var message1 = vm.$t('cart_invalid_lunch_time')
        var message2 = vm.$t('cart_invalid_hut_day')
        var message3 = vm.$t('cart_invalid_order_time')
        var message4 = vm.$t('cart_invalid_open_time')
        var message5 = vm.$t('cart_invalid_min_cart')
        var message6 = vm.$t('cart_empty')
        var message7 = vm.$t('cart_invalid_current_order_time')
        vm.axios.apiCart.addToCart(item,
          function (response) {
            cart = response.data.data.item
            if (cart.coupon_error.length > 0) {
              let error = cart.coupon_error[0]
              let message = vm.getMessageFromGms({error: {code: error.error_code, message: error.message}}).replace('%@', error.coupon_message)
              vm.$notify({
                type: 'warn',
                title: message
              })
            }
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }, function (data) {
            switch (data.error.code) {
              case vm.$const.CART_CODE.OPENING_NOT_FOUND:
                vm.$notify({
                  type: 'error',
                  title: message
                })
                break
              case vm.$const.CART_CODE.SELLINGTIME:
                vm.$notify({
                  type: 'error',
                  title: message
                })
                break
              case vm.$const.CART_CODE.INVALIDHUTDAY:
                vm.$notify({
                  type: 'error',
                  title: message2
                })
                break
              case vm.$const.CART_CODE.INVALIDLUNCHTIME:
                vm.$notify({
                  type: 'error',
                  title: message1
                })
                break
              case vm.$const.CART_CODE.NOTFOUND:
                self.commit(vm, [])
                vm.$root.$emit('onRedirectToHome')
                break
              case vm.$const.CART_CODE.INVALIDORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message3
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.INVALIDOPENTIME:
                vm.$notify({
                  type: 'error',
                  title: message4
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.INVALIDMINCART:
                vm.$notify({
                  type: 'error',
                  title: message5
                })
                break
              case vm.$const.CART_CODE.EMPTYCART:
                vm.$notify({
                  type: 'error',
                  title: message6
                })
                break
              case vm.$const.CART_CODE.INVALIDCURRENTORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message7
                })

                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
                break
              case vm.$const.CART_CODE.SEVICEUNAVAILABLEDELIVERY:
                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, true)
                break
              case vm.$const.CART_CODE.SEVICEUNAVAILABLEPICKUP:
                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_PICKUP, true)
                break
              case vm.$const.CART_CODE.CART_EMPTY_ADD_ON:
                vm.$notify({
                  type: 'error',
                  title: vm.getMessageFromGms(data) || vm.$t('cart_empty_add_on')
                })
                break;
              default:
                self._modalActionShow(vm, data.error.code, data.error.message)
                break
            }
          }
        )
      },
      updateCart: function (vm, item) {
        let cart = this.get(vm)
        let self = this

        if (cart.uuid) {
          item.group.cart_id = cart.uuid
        }

        item.group.advance_order = vm.$disposition.getByKey(vm, 'advanceOrder', 0)
        item.group.order_time = vm.convertDateTimeToUTC(item.group.order_time)
        if(vm.$disposition.getByKey(vm, 'orderType', vm.$const.DELIVERY) == vm.$const.DELIVERY){
          item.lat = vm.$disposition.getByKey(vm, 'lat', ''),
          item.long = vm.$disposition.getByKey(vm, 'long', '')
        }
        if (cart.hasOwnProperty('is_use_condiment')) {
          item.group.require_condiment = cart.is_use_condiment
        }
        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.group.require_cutlery = cart.is_use_cutlery
        }
        // Send to API
        // Received response from API and set for cart
        var title = vm.$t('cart.update_success')
        var message = vm.$t('cart_invalid_selling_time') + (item.selling_start ? vm.convertUTCToClientTime(item.selling_start).format('YYYY-MM-DD HH:mm:ss') : '')
        var message1 = vm.$t('cart_invalid_lunch_time')
        var message2 = vm.$t('cart_invalid_hut_day')
        var message3 = vm.$t('cart_invalid_order_time')
        var message4 = vm.$t('cart_invalid_open_time')
        var message5 = vm.$t('cart_invalid_min_cart')
        var message6 = vm.$t('cart_empty')
        var message7 = vm.$t('cart_invalid_current_order_time')
        vm.axios.apiCart.updateItemCart(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }, function (data) {
            switch (data.error.code) {
              case vm.$const.CART_CODE.SELLINGTIME:
                vm.$notify({
                  type: 'error',
                  title: message
                })
                break
              case vm.$const.CART_CODE.INVALIDHUTDAY:
                vm.$notify({
                  type: 'error',
                  title: message2
                })
                break
              case vm.$const.CART_CODE.INVALIDLUNCHTIME:
                vm.$notify({
                  type: 'error',
                  title: message1
                })
                break
              case vm.$const.CART_CODE.NOTFOUND:
                self.commit(vm, [])
                vm.$root.$emit('onRedirectToHome')
                break
              case vm.$const.CART_CODE.INVALIDORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message3
                })
                break
              case vm.$const.CART_CODE.INVALIDOPENTIME:
                vm.$notify({
                  type: 'error',
                  title: message4
                })
                break
              case vm.$const.CART_CODE.INVALIDMINCART:
                vm.$notify({
                  type: 'error',
                  title: message5
                })
                break
              case vm.$const.CART_CODE.EMPTYCART:
                vm.$notify({
                  type: 'error',
                  title: message6
                })
                break
              case vm.$const.CART_CODE.INVALIDCURRENTORDERTIME:
                vm.$notify({
                  type: 'error',
                  title: message7
                })
                break
              default:
                self._modalActionShow(vm, data.error.code, data.error.message)
                break
            }
          }
        )
      },
      updateOrderTime: function (vm, item) {
        let self = this
        let cart = this.get(vm)
        if (!cart.uuid) {
          return false
        }
        item.cart_uuid = cart.uuid

        item.order_time = vm.convertDateTimeToUTC(item.order_time)

        if(vm.$disposition.getByKey(vm, 'orderType', vm.$const.DELIVERY) == vm.$const.DELIVERY){
          item.lat = vm.$disposition.getByKey(vm, 'lat', ''),
          item.long = vm.$disposition.getByKey(vm, 'long', '')
        }

        vm.axios.apiCart.updateCartData(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
          }, function (data) {
          }
        )
      },
      updateCartUuid: function (vm) {
        let cart = this.get(vm)
        const self = this

        if (!cart.uuid) {
          return false
        }
        let item = {}
        item.cart_uuid = cart.uuid
        if (cart.hasOwnProperty('is_use_condiment')) {
          item.require_condiment = cart.is_use_condiment
        }

        if (cart.hasOwnProperty('is_use_cutlery')) {
          item.require_cutlery = cart.is_use_cutlery
        }

        vm.axios.apiCart.updateCartData(item,
          function (response) {
            cart = response.data.data.item
            self.commit(vm, cart)
          }, function (data) {
          }
        )
      },
      processApplyCoupon(vm, data, type, callBackSuccess = function () {}) {
        var cart = this.get(vm)
        let self = this
        if (!cart.uuid) {
          let params = {
            outlet_code: vm.$disposition.getByKey(vm, 'outletCode'),
            order_type: vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0),
            order_time: vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''), vm.$disposition.getByKey(vm, 'collectionTimeValue', '')),
            advance_order: vm.$disposition.getByKey(vm, 'advanceOrder', 0)
          }
          vm.axios.apiCart.createCart(params,
              function (response) {
                data.cart_id = response.data.data.item.uuid
                cart.uuid = response.data.data.item.uuid
                self.commit(vm, cart)
                self._processApplyCoupon(vm, data, type, callBackSuccess)
              }, function (error) {
                self._processApplyCoupon(vm, data, type, callBackSuccess)
              }
          )
        } else {
          this._processApplyCoupon(vm, data, type, callBackSuccess)
        }
      },
      _processApplyCoupon(vm, data, type, callBackSuccess) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.apply_coupon_success')
        vm.axios.apiCart.applyCoupon(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            let coupons = {
              menu: cart.free_items,
              coupon: data.coupon_code
            }
            let layer = {name: '', couponCode: data.coupon_code, price: 0}
            if (coupons.menu && coupons.menu.length > 0) {
              layer.name = coupons.menu[0].name
              layer.price = coupons.menu[0].price
            }
            vm.eventTrackingCoupon(vm, layer)
            self.commit(vm, cart, coupons)
            if (response.data.data.info.hasOwnProperty('topping') && !vm.empty(response.data.data.info.topping)) {
              let title = vm.$t('message')
              let name = response.data.data.info.topping.name
              let price = response.data.data.info.topping.price
              if (!isNaN(price)) {
                price = vm.formatNumDisplay(price)
              }
              if (name && name.length > 0) {
                name = name.join(', ')
              } else {
                name = ''
              }
              let message = vm.$t('coupon_free_topping', {name: name, price: price, currency_unit: vm.$const.CURRENCY})
              vm.$root.$emit('onShowNotification', title, message)
            }
            vm.$notify({
              type: 'success',
              title: title
            })
            vm.$store.commit('setCouponMessage', '')
            callBackSuccess()
          }, function (error) {
            if (error.status === false) {
              // mapping message
              let message = vm.getMessageFromGms(error)
              let coupon = vm.$const.COUPON_ALLOW[error.error.code]
              if ((coupon && coupon.fields && typeof coupon.fields !== 'undefined') || !message) {
                message = error.error ? error.error.message : ''
              }
              if (error.error.code === vm.$const.DISCOUNT_EXCLUDE_ITEM || !message) {
                message = message.replace('%@', error.error.info.coupon_message)
              }
              if (error.error.code === vm.$const.REQUIRE_ITEM_INFO || !message) {
                message = message.replace('%@', error.error.info.coupon_message)
              }
              // vm.$store.commit('setCouponMessage', message)
              vm.$modal.show(modalMessage,{title : 'Error',message : message})
            } else {
              vm.$store.commit('setCouponMessage', '')
            }
            callBackSuccess()
          }
        )
      },
      applyCoupon: function (vm, data, callBackSuccess) {
        this.processApplyCoupon(vm, data, 'single', callBackSuccess)
      },
      applyCouponFromList: function (vm, data) {
        this.processApplyCoupon(vm, data, 'list')
      },
      removeCoupon: function (vm, data, isVoucher = false) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.remove_coupon_success')
        if (isVoucher) {
          title = vm.$t('cart.remove_voucher_success')
        }
        if (cart.uuid) {
          data.cart_id = cart.uuid
        }
        vm.axios.apiCart.removeCoupon(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            })
          }
        )
      },
      updateQuantity: function (vm, data) {
        let cart = this.get(vm)
        let self = this
        var title = vm.$t('cart.update_quantity_success')
        if (cart.uuid) {
          data.cart_uuid = cart.uuid
        }
        vm.axios.apiCart.updateCartQuantity(data,
          function (response) {
            vm.$emit('close')
            cart = response.data.data.item
            self.commit(vm, cart)
            vm.$notify({
              type: 'success',
              title: title
            });
          }, function (error) {
            vm.$emit('close')
            if (!vm._.isEmpty(vm._.get(error, 'error.message'))) {
              const err_code = vm._.get(error, 'error.code')
              const err_msg = vm._.get(error, 'error.message')

              vm.$notify({
                type: 'error',
                title: err_msg
              });
            }
          }
        )
      },
      // remove item from cart
      remove: function (vm, id) {
        let data = {}
        let self = this
        let cart = this.get(vm)

        data['cart_id'] = cart.uuid
        let items = cart.data
        let newitems = []
        let removeItems = []

        for (let i = 0; i < items.length; i++) {
          if (items[i].id != id) {
            newitems.push(items[i])
          }else{
            removeItems.push(items[i])
          }
        }
        cart.data = newitems
        vm.smartechRemoveItem(vm,removeItems)
        // Send to API
        // Received response from API and set for cart
        data['item_id'] = id
        vm.axios.apiCart.removeCart(data, function (response) {
          cart = response.data.data.item
          self.commit(vm, cart)
        }, function (data) {
          if ([vm.$const.CART_CODE.NOTFOUND].indexOf(data.error.code) >= 0) {
            self.commit(vm, [])
            vm.$root.$emit('onRedirectToHome')
          }
        })
      },
      removeAll: function (vm, callback) {
        let data = {}
        let self = this
        let cart = this.get(vm)

        if(cart && cart.uuid){
          vm.axios.apiCart.removeCartByUuid(cart.uuid, function (response) {
            cart = {}
            self.commit(vm, cart)
            self.$root.$emit('cartUpdate', self.get(self))

            if(callback){
              callback(null, true)
            }
          }, function (data) {
            if ([vm.$const.CART_CODE.NOTFOUND].indexOf(data.error.code) >= 0) {
              self.commit(vm, [])

              if(callback){
                callback(data.error.code, null)
              }
            }
          })
        }else{
          callback(false, null)
        }
      },
      clearFreeItem: function (vm) {
        let cart = this.get(vm)
        delete cart['current_coupon_item']
        cart.free_items = []
        this.commit(vm, cart, null, true)
      },
      commit: function (vm, cart, coupon, hideTracking = false) {
        if (!cart || vm.empty(cart)) {
          vm.$session.set('cart', {})
          vm.$root.$emit('cartUpdate', this.get(vm))
        } else {
          if (cart.revenue_monster_vouchers && cart.revenue_monster_vouchers.vouchers_error.length > 0) {
            for (let i = 0; i < cart.revenue_monster_vouchers.vouchers_error.length; i++) {
              let errorVoucher = cart.revenue_monster_vouchers.vouchers_error[i]
              vm.$notify({
                type: 'error',
                title: `${errorVoucher.name} has already been voided.`
              })
            }
          }
          cart.current_coupon_item = {}
          if (coupon && coupon.menu && coupon.menu.length > 0) {
            cart.current_coupon_item = {
              'uuid': coupon.menu[0].uuid,
              'is_combo': coupon.menu[0].is_combo || false,
              'coupon': coupon.coupon,
              'menu': coupon.menu
            }
          }
          vm.$session.set('cart', cart)
          vm.cart = cart
          vm.$root.$emit('cartUpdate', cart.data)
          if (coupon && coupon.menu && coupon.menu.length > 0) {
            vm.$root.$emit('couponItemImplement', cart.current_coupon_item)
          }
        }

        if (typeof hideTracking === 'undefined' || !hideTracking) {
          vm.eventTrackingLoadCart(vm)
        }
      },
      getToppingById: function (a) {
        let arr = []
        for (let i = 0; i < a.length; i++) {
          arr.push(a[i].id)
        }
        return arr
      },
      checkout: function (vm, card_uuid) {
        let data = {}
        const self = this
        data['cart_uuid'] = card_uuid
        if(vm.$disposition.getByKey(vm, 'orderType', vm.$const.DELIVERY) == vm.$const.DELIVERY) {
          data['lat'] = vm.$disposition.getByKey(vm, 'lat', '')
          data['long'] = vm.$disposition.getByKey(vm, 'long', '')
        }
        this.getDetail(vm)
        vm.axios.apiCart.checkoutCartByUuid(data, (response) => {
          if(vm.cart.is_use_free_item == 1 || vm.$session.get("vouchers")) {
            vm.$router.push({'name': 'checkout'})
          } else {
            vm.$modal.show(freeItem, {
                free_items: response.data.data && response.data.data.item && response.data.data.item.free_list ? response.data.data.item.free_list.map((single) => {
                  let category = single.display_categories && single.display_categories.length > 0 ? single.display_categories[0].uuid : ''
                  let data = {}
                  data = {
                    "id": single.id,
                    "name": single.name,
                    "imagelink": single.image.desktop_thumbnail ? single.image.desktop_thumbnail : 'https://static.pizzahut.jp/jp/menu/single/desktop_thumbnail_946f4682-8269-4529-9507-da07b3f24a06.jpg',
                    "baseprice": single.min_price,
                    "promotionprice": single.display_price,
                    "uuid": single.uuid,
                    "toppings": single.toppings,
                    "category_id": single.category ? single.category.uuid : '',
                    "selling_start": single.selling_start,
                    "type": single.type,
                    "groups": single.groups,
                  }
                  return data
                }) : []
              },
              {
                'class': 'modal-coupon'
              },
              {
                'before-open': function () {
                  document.body.classList.add('modal-open')
                },
                'before-close': function () {
                  document.body.classList.remove('modal-open')
                }
              })
          }
      }, (errorResponse) => {
          const { error } = errorResponse;

          // Process for case cart has some invalid items.
          if (error.code === "CART-10") {
            vm.$notify({
              type: 'warn',
              title: vm.$t('cart.include_invalid_items')
            })
            vm.$root.$emit('updateCartData')
          } else if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(error.code) >= 0){
            self._modalActionShow(vm, error.code, error.message)
          } else if ([vm.$const.CART_CODE.NOTFOUND].indexOf(error.code) >= 0) {
            self.commit(vm, [])
            vm.$root.$emit('onRedirectToHome')
          } else {
            self.commit(vm, [])
            vm.$notify({
              type: 'error',
              title: error.message
            })
          }
        })
      }
    }
  }
}

export default Cart



// WEBPACK FOOTER //
// ./src/plugins/cart.js